import { render, staticRenderFns } from "./OnTrialCommentList.vue?vue&type=template&id=7a81fcdf&scoped=true&"
import script from "./OnTrialCommentList.vue?vue&type=script&lang=js&"
export * from "./OnTrialCommentList.vue?vue&type=script&lang=js&"
import style0 from "./OnTrialCommentList.vue?vue&type=style&index=0&id=7a81fcdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81fcdf",
  null
  
)

export default component.exports